import { useState, useEffect, useCallback } from 'react'
import { MdArrowBack } from 'react-icons/md'
import { useParams, useNavigate } from 'react-router-dom'
import { Button, LoadingSpinner } from '../../components/ui'
import { useAirport } from '../../hooks/useAirport'
import AirportForm from '../../modules/airports/AirportForm'

function AirportFormPage() {
  const { airportId } = useParams()
  const navigate = useNavigate()
  const isEditing = !!airportId
  const [airport, setAirport] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const { getAirportByIdAsync } = useAirport()

  const loadAirport = useCallback(async () => {
    try {
      setIsLoading(true)
      const airportData = await getAirportByIdAsync(airportId)
      setAirport(airportData)
    } catch (error) {
      console.error('Error loading airport:', error)
    } finally {
      setIsLoading(false)
    }
  }, [airportId]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isEditing && airportId) {
      loadAirport()
    }
  }, [airportId, isEditing]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleBack = () => {
    navigate(`/airports/${airportId}`)
  }

  const handleSave = () => {
    navigate(`/airports/${airportId}`)
  }

  const handleCancel = () => {
    navigate(`/airports/${airportId}`)
  }

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  return (
    <div className="max-w-3xl mx-auto">
      <div className="flex justify-start mb-4">
        <Button variant="ghost" onClick={handleBack}>
          <MdArrowBack />
        </Button>
      </div>
      <div className="flex items-center space-x-2 mb-6">
        <h1 className="text-2xl font-bold text-neutral-900 dark:text-white">
          {isEditing ? 'Edit Airport' : 'Add Airport'}
        </h1>
      </div>
      <AirportForm
        airport={airport}
        mode={isEditing ? 'edit' : 'create'}
        onSave={handleSave}
        onCancel={handleCancel}
      />
    </div>
  )
}

export default AirportFormPage
